import DefaultAttributeInput from './DefaultAttributeInput';

export default DefaultAttributeInput;
